import { Check, Minus } from "lucide-react";

/* Concise list of statements. variant "do" shows ticks; "avoid" shows a muted dash. */
export default function ClauseList({ items, variant = "do" }) {
  const Icon = variant === "avoid" ? Minus : Check;
  return (
    <ul className={`lc-list${variant === "avoid" ? " lc-list-plain" : ""}`}>
      {items.map((item) => (
        <li key={item}>
          <Icon size={16} aria-hidden="true" />
          <span>{item}</span>
        </li>
      ))}
    </ul>
  );
}
